import {
    InputAdornment,
    Paper,
    TableBody,
    TableCell,
    TableFooter,
    TableRow,
    Toolbar,
} from '@mui/material';
import { makeStyles } from '@mui/styles';

import { DeleteForever, Search } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import EditOutlinedIcon from '@mui/icons-material/Edit';
import React, { useState } from 'react';
import NumberFormat from 'react-number-format';
import Moment from '../../components/Moment';
import { Controls } from '../../components/controls/Controls';
import Popup from '../../components/Popup';
import useTable from '../../components/useTable';
import GastosForm from './GastosForm';
import { filterOnAnyField } from '../../utils';

const useStyles = makeStyles((theme) => ({
    pageContent: {
        margin: theme.spacing(1),
        padding: theme.spacing(1),
    },
    searchInput: {
        width: '75%',
    },
    newButton: {},
    refreshButton: {},
}));

export default function Gastos({ values, setValues, setIsDirty }) {
    const classes = useStyles();

    const [openPopupGastos, setOpenPopupGastos] = useState(false);
    const [filterFn, setFilterFn] = useState({
        fn: (items) => items,
    });
    const [recordForEdit, setRecordForEdit] = useState();

    const headCells = [
        { id: 'tramoId', label: 'Numero de Tramo' },
        { id: 'tipoPago', label: 'Tipo de Gasto' },
        { id: 'descripcion', label: 'Descripcion' },
        { id: 'fechaPago', label: 'Fecha' },
        { id: 'cantidad', label: 'Cantidad' },
        { id: 'idMovimientoBancario', label: 'ID Mov. Bancario' },
        { id: 'idCuentaBancaria', label: 'ID Cuenta bancaria' },
        { id: 'actions', label: 'Acciones', disableSorting: true },
    ];
    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting,
    } = useTable(values.otrosGastos, headCells, filterFn, 100, 'fechaPago', 'desc');
    const [filter, setFilter] = useState();

    const handleSearch = (e) => {
        const { target } = e;
        setFilter(target.value);
        setFilterFn({
            fn: (items) => {
                if (target.value === '') {
                    return items;
                }
                return filterOnAnyField(items, target.value.toLowerCase());
            },
        });
    };
    const addOrEdit = (gasto) => {
        let otrosGastosList;
        console.log(gasto);
        if (gasto.id === 0) {
            const addedGasto = {
                ...gasto,
                id: null,
            };
            otrosGastosList = values.otrosGastos.concat(addedGasto);
        } else {
            const id = values.otrosGastos.findIndex((o) => o.id === gasto.id);
            otrosGastosList = values.otrosGastos
                .slice(0, id)
                .concat([gasto])
                .concat(values.otrosGastos.slice(id + 1));
        }
        setValues({
            ...values,
            otrosGastos: otrosGastosList,
        });
        setOpenPopupGastos(false);
        setIsDirty(true);
    };

    const openInPopup = (item) => {
        setRecordForEdit(item);
        setOpenPopupGastos(true);
    };

    const deleteItem = (item) => {
        const newGastos = values.otrosGastos.filter((f) => f.id !== item.id);
        setValues({
            ...values,
            otrosGastos: newGastos,
        });
        setIsDirty(true);
    };
    return (
        <>
            <Paper className={classes.pageContent}>
                <Toolbar>
                    <Controls.Input
                        className={classes.searchInput}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position='end'>
                                    {' '}
                                    <Search />
                                </InputAdornment>
                            ),
                        }}
                        label='Buscar'
                        onChange={handleSearch}
                        value={filter}
                    />
                    <Controls.Button
                        className={classes.newButton}
                        onClick={() => {
                            setRecordForEdit(null);
                            setOpenPopupGastos(true);
                        }}
                        startIcon={<AddIcon />}
                        text='Agregar Nuevo'
                        variant='outlined'
                    />
                </Toolbar>
                <TblContainer>
                    <TblHead />
                    <TableBody>
                        {recordsAfterPagingAndSorting().map((item) => (
                            <TableRow
                                key={item.id}
                                sx={item.idMovimientoBancario ? { backgroundColor: '#e8f5e9' } : {}}
                            >
                                <TableCell>{item.tramoId}</TableCell>
                                <TableCell>{item.tipoPago.id}</TableCell>
                                <TableCell>{item.descripcion}</TableCell>
                                <TableCell>
                                    <Moment date={item.fechaPago} />
                                </TableCell>
                                <TableCell>
                                    <NumberFormat
                                        decimalScale={2}
                                        displayType='text'
                                        prefix='$'
                                        thousandSeparator
                                        value={item.cantidad}
                                    />
                                </TableCell>
                                <TableCell>{item.idMovimientoBancario ?? ''}</TableCell>
                                <TableCell>{item.idCuentaBancaria ?? ''}</TableCell>
                                <TableCell>
                                    <Controls.ActionButton
                                        color='primary'
                                        onClick={() => {
                                            openInPopup(item);
                                        }}
                                    >
                                        <EditOutlinedIcon fontSize='small' />
                                    </Controls.ActionButton>
                                    <Controls.ActionButton
                                        color='primary'
                                        onClick={() => {
                                            deleteItem(item);
                                        }}
                                    >
                                        <DeleteForever fontSize='small' />
                                    </Controls.ActionButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                    {values.otrosGastos?.length > 0 && (
                        <TableFooter>
                            <TableRow>
                                <TableCell colSpan={4} sx={{ fontWeight: 'bold', fontSize: '1rem' }}>Total</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', fontSize: '1rem' }}>
                                    <NumberFormat
                                        decimalScale={2}
                                        displayType='text'
                                        prefix='$'
                                        thousandSeparator
                                        value={values.otrosGastos.reduce((sum, g) => sum + (parseFloat(g.cantidad) || 0), 0)}
                                    />
                                </TableCell>
                                <TableCell colSpan={2} />
                            </TableRow>
                        </TableFooter>
                    )}
                </TblContainer>
                <TblPagination />
            </Paper>
            <Popup
                openPopup={openPopupGastos}
                setOpenPopup={setOpenPopupGastos}
                title='Gastos'
            >
                <GastosForm
                    addOrEdit={addOrEdit}
                    recordForEdit={recordForEdit}
                    valuesViaje={values.tramos}
                />
            </Popup>
        </>
    );
}
